import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { CancelSubscriptionRequest } from '$/requests/CancelSubscription.ts';
import { queryClient } from '@/main.tsx';

const useCancelSubscription = () => {
  const client = supabaseClient;

  const mutationFn = async (request: CancelSubscriptionRequest) => {
    return cancelSubscription(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

export default useCancelSubscription;

async function cancelSubscription(
  client: SupabaseClient,
  request: CancelSubscriptionRequest
): Promise<BackendSuccessResponse<null>> {
  const { data, error } = await client.functions.invoke('cancel_subscription', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
